import { useTranslation } from 'react-i18next';
import { Logo } from '@/components/Logo';
import { LoginForm } from './components/loginForm';
import { RightPanel } from './components/rightPanel';
import { CertificationBadges } from './components/certificationBadges';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

interface LoginPageProps {
  prefillEmail?: string;
}

export function LoginPage({ prefillEmail }: LoginPageProps) {
  const { t } = useTranslation();
  useDocumentTitle('pageTitles.login');

  return (
    <div className="grid min-h-svh lg:grid-cols-[40%_60%]">
      {/* Left Column - Login Form */}
      <div className="flex flex-col gap-4 p-6 md:p-10">
        <div className="flex items-center justify-center flex-1">
          <div className="w-full max-w-sm">
            {/* Logo Header */}
            <div className="flex flex-col items-center mb-8">
              <Logo className="mb-2" />
              <div className="text-sm text-fg-secondary text-center mt-4">{t('welcomeText')}</div>
            </div>

            {/* Login Form */}
            <LoginForm prefillEmail={prefillEmail} />
          </div>
        </div>

        {/* Certification / trust badges pinned to the bottom of the page */}
        <CertificationBadges />
      </div>

      {/* Right Column - Animated Hexagon Pattern */}
      <RightPanel />
    </div>
  );
}
